import React from 'react';
import ButtonGeneral from '../buttons/buttonGeneral';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { types } from '../../../../redux/types';
import LoadingButtonGeneral from '../buttons/loadingButtonGeneral';

type Props = {
    stepsLength: number;
    onClick?: any;
    onClickBack?: any;
    titleBack?: string | undefined;
    titleAdd?: string | undefined;
    disabledNext?: false | boolean;
    loading?: false | boolean;
};

const StepperButtons = ({
    stepsLength,
    onClick,
    onClickBack,
    disabledNext,
    loading,
    titleBack = 'Atrás',
    titleAdd,
}: Props) => {
    const dispatch: any = useDispatch();
    const { activeStep } = useSelector((state: RootState) => state.general);

    return (
        <>
            {activeStep !== stepsLength && (
                <Box
                    sx={{ display: 'flex', flexDirection: 'row', pt: 2, mt: 1 }}
                >
                    {activeStep > 0 && (
                        <ButtonGeneral
                            onClick={
                                onClickBack
                                    ? onClickBack
                                    : () =>
                                        dispatch({ type: types.backStepper })
                            }
                            startIcon={<ArrowBackIcon color="secondary" />}
                            title={titleBack}
                        />
                    )}
                    <Box sx={{ flex: '1 1 auto' }} />
                    <LoadingButtonGeneral
                        startIcon={
                            activeStep === stepsLength - 1 ? (
                                <SaveIcon color="secondary" />
                            ) : (
                                <ArrowForwardIcon color="secondary" />
                            )
                        }
                        onClick={onClick}
                        title={
                            titleAdd
                                ? titleAdd
                                : activeStep === stepsLength - 1
                                    ? 'Guardar'
                                    : 'Siguiente'
                        }
                        loading={loading}
                        loadingPosition="start"
                        disabled={disabledNext}
                    />
                </Box>
            )}
        </>
    );
};

export default StepperButtons;
